/**
 * Confidence Ring — circular progress indicator with animated SVG.
 * Extracted from InterviewChatPage for reuse in ReviewView.
 */

import React from 'react';
import { motion } from 'framer-motion';

export const confidenceColor = (score: number) => {
  if (score >= 0.6) return 'bg-green-400';
  if (score >= 0.3) return 'bg-amber-400';
  return 'bg-muted-foreground/20';
};

export const confidenceStrokeColor = (score: number) => {
  if (score >= 0.6) return '#4ade80';
  if (score >= 0.3) return '#fbbf24';
  return '#a1a1aa';
};

export const ConfidenceRing: React.FC<{ value: number; size?: number }> = ({ value, size = 22 }) => {
  const strokeWidth = 2.5;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - value * circumference;
  const pct = Math.round(value * 100);

  return (
    <div className="flex items-center gap-1">
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2} cy={size / 2} r={radius}
          fill="none" stroke="currentColor" strokeWidth={strokeWidth}
          className="text-muted-foreground/15"
        />
        <motion.circle
          cx={size / 2} cy={size / 2} r={radius}
          fill="none" stroke={confidenceStrokeColor(value)}
          strokeWidth={strokeWidth} strokeLinecap="round"
          strokeDasharray={circumference}
          initial={{ strokeDashoffset: circumference }}
          animate={{ strokeDashoffset: offset }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        />
      </svg>
      <span className="text-[10px] text-muted-foreground tabular-nums font-medium">
        {pct}%
      </span>
    </div>
  );
};
